// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screenActions{width:20%}.btn-width{width:auto}.error{height:15%}@media screen and (max-width:1300px){.screenActions{width:23%}}", ""]);
// Exports
module.exports = exports;
